/* screens/workspace-engine.jsx — VD-03 · Workspace default-engine admin control (PY-44's face).
   One control in the admin cost-controls cluster: pick the workspace's default build engine.
   It GATES two downstream things — the dashboard's meters (codex → usage quota, else $ spend,
   i.e. VD-01) and the engine prefilled on New Build. Admin-only; members see it read-only.
   Writes RBAC.setWorkspaceEngine (persisted; LIVE-WIRE → PY-44's PATCH); VD-01's surfaces react
   live via goose-rbac-change + goose-codex-usage.
   Ported from 🛩️ Viper's VD-03 prototype, adapted to the live window.RBAC dialect (the live app
   uses window.RBAC, not MAV.rbac; workspaces come from RBAC.engineWorkspaces()). */

const { useState: useWseState } = React;

const WSE_ENGINES = [
  { id: 'codex',    name: 'Codex CLI', status: 'live',     note: 'agentic · sub-$0' },
  { id: 'bullseye', name: 'Bullseye',  status: 'preview',  note: 'maturing' },
  { id: 'legacy',   name: 'Legacy',    status: 'archived', note: 'multi-model swarm' },
];

function WorkspaceEngineControl() {
  const R = window.RBAC;
  // Guarded-hook idiom (same as dashboard.jsx): window.RBAC is set once at load, so the
  // condition is stable across renders → Rules of Hooks hold. Re-renders on a workspace/engine flip.
  const v = (R && R.useViewer) ? R.useViewer() : null;
  const canEdit = !!(v && R.requireRole && R.requireRole('cost_controls', v));  // ORG-01: matrix-driven (admin seat / PM) — no tier hardcode
  const wss = (R && R.engineWorkspaces) ? R.engineWorkspaces(v) : [];
  const [wsId, setWsId] = useWseState(wss[0] ? wss[0].id : '');
  const ws = wss.find(w => w.id === wsId) || wss[0] || null;
  const engine = ws ? ws.defaultEngine : 'codex';
  const pick = (eid) => { if (canEdit && ws && R.setWorkspaceEngine) R.setWorkspaceEngine(ws.id, eid); };
  const meter = engine === 'codex' ? 'usage quota (no $)' : '$ spend meters';
  const engName = (WSE_ENGINES.find(e => e.id === engine) || {}).name || engine;

  return (
    <div className="card card-pad wse-card">
      <div className="sec-head">
        <span className="sec-title"><I.jet size={15} style={{ verticalAlign: '-2px', marginRight: 6, color: 'var(--brand-amber)' }} />Default build engine</span>
        {canEdit
          ? <select className="wse-ws" value={ws ? ws.id : ''} onChange={e => setWsId(e.target.value)} aria-label="Workspace">
              {wss.map(w => <option key={w.id} value={w.id}>{w.name}</option>)}
            </select>
          : <span className="chip" style={{ fontSize: 10.5 }}><I.lock size={11} /> Admin only</span>}
      </div>
      <p className="cost-help">The engine new builds use by default in <b>{ws ? ws.name : 'this workspace'}</b>. It <b>gates the dashboard's meters</b> (codex shows a usage quota; $ meters apply only to metered engines) and prefills the engine on New Build.</p>

      <div className={'wse-seg' + (canEdit ? '' : ' disabled')}>
        {WSE_ENGINES.map(e => (
          <button key={e.id} type="button"
            className={'wse-opt' + (engine === e.id ? ' sel' : '')}
            disabled={!canEdit} onClick={() => pick(e.id)} aria-pressed={engine === e.id}>
            <span className="wse-radio"></span>
            <span className="wse-main"><span className="wse-name">{e.name}</span><span className="wse-note">{e.note}</span></span>
            <span className={'wse-status wse-' + e.status}>{e.status}</span>
          </button>
        ))}
      </div>

      <div className="wse-conseq">
        <I.arrow size={13} /> <span><b>{ws ? ws.name : 'This workspace'}</b> dashboard shows <b>{meter}</b> · new builds prefill <b>{engName}</b></span>
      </div>
      {!canEdit && <p className="muted" style={{ fontSize: 11.5, marginTop: 10 }}><I.lock size={11} style={{ verticalAlign: '-1px', marginRight: 4 }} />Only workspace admins can change the default engine. Ask an admin to switch it.</p>}
    </div>
  );
}

window.WorkspaceEngineControl = WorkspaceEngineControl;
